import { z } from 'zod';
import { ApiPath, RoleCode } from '@app/shared';
import { apiGet } from '../../lib/api';

const permissionRoleSchema = z.object({
  allowed: z.boolean(),
  scope: z.enum(['global', 'school', 'self']).nullable(),
});

const permissionDefSchema = z.object({
  code: z.string(),
  label: z.string(),
  module: z.string(),
  description: z.string(),
  roles: z.object({
    [RoleCode.ADMIN]: permissionRoleSchema,
    [RoleCode.GURU]: permissionRoleSchema,
    [RoleCode.KEPALA_SEKOLAH]: permissionRoleSchema,
  }),
});

export type PermissionDef = z.infer<typeof permissionDefSchema>;

export async function getPermissions() {
  return apiGet(ApiPath.SYSTEM.PERMISSIONS, z.array(permissionDefSchema));
}
